<template>
  <div
    style="/*background-color: white; */ font-size: 12px !important;"
  >
    <v-progress-linear
      class="mt-2"
      v-if="loading"
      color="deep-purple accent-4"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>
    <div id="container">
      <v-layout row>
        <v-flex style="background-color: white !important;">
          <div
            v-if="!loading"
          >
            <DriverSearchBox
              :query="query"
              @councilSelected="getDrivers"
              @search="search"
              @clear="clear"
            />
          </div>
        </v-flex>
      </v-layout>
      <div class="schedule-vue-sample">
        <div class="control-section">
          <ejs-schedule
            v-if="!loading"
            id="Schedule"
            row-auto-height="true"
            :allow-inline="false"
            :min-day="yesterday"
            :start-hour="startHour"
            width="100%"
            :event-settings="eventsCollection"
            :selected-date="selectedDate"
            :current-view="selectedView"
            :group="group"
            :resource-header-template="resourceHeaderTemplate"
            :render-cell="onRenderCell"
            css-class="quick-info-template"
            @navigating="navigateSchedule"
            @popupOpen="popupOpen"
            @eventRendered="onEventRendered"
          >
            <e-views>
              <e-view
                option="TimelineDay"
                :time-scale="timeScale"
              />
              <e-view
                option="TimelineWeek"
                :time-scale="timeScaleWeek"
              />
              <e-view option="TimelineMonth" />
            </e-views>
            <e-resources>
              <e-resource
                style="width: 100px !important;"
                field="driverId"
                title="RoomType"
                name="MeetingRoom"
                :data-source="drivers"
                text-field="name"
                id-field="id"
                color-field="color"
              />
            </e-resources>
          </ejs-schedule>
        </div>
      </div>
      <div
        v-if="query.pagination"
        class="text-center"
      >
        <v-flex v-if="!loading">
          <v-row
            justify="center"
            class="ma-2"
          >
            <v-btn
              class="ma-1"
              small
              :disabled="pagination.page <= 1"
              @click="changePage(pagination.page - 1)"
            >
              <
            </v-btn>
            <v-btn
              class="ma-1"
              small
              :disabled="noMoreResults == true"
              @click="changePage(pagination.page + 1)"
            >
              >
            </v-btn>
          </v-row>
        </v-flex>
      </div>
    </div>
  </div>
</template>

<script>



// eslint-disable-next-line no-unused-vars
function viewBooking (booking) {
  window.open('/booking/' + booking.id )
}
import Vue from 'vue';
import {SchedulePlugin, TimelineViews, TimelineMonth} from '@syncfusion/ej2-vue-schedule';
import axios from 'axios'
import moment from 'moment'
import DriverSearchBox from "@/components/planner/DriverPlannerSearchBox.vue";
import DriverPlanner from "@/components/planner/DriverPlanner.vue";

require('@syncfusion/ej2-base/styles/material.css');
require('@syncfusion/ej2-buttons/styles/material.css');
require('@syncfusion/ej2-calendars/styles/material.css');
require('@syncfusion/ej2-dropdowns/styles/material.css');
require('@syncfusion/ej2-inputs/styles/material.css');
require('@syncfusion/ej2-navigations/styles/material.css');
require('@syncfusion/ej2-popups/styles/material.css');
require('@syncfusion/ej2-vue-schedule/styles/material.css');


Vue.use(SchedulePlugin);


var resourceHeaderTemplateVue = Vue.component('headerTemplate', {
  data() {
    return {
      plannerDialog: false,
      selectedDriverId: '',
      data: {}
    }
  },
  components: {
    DriverPlanner
  },
  methods: {
    calculateWorkedHours(timesheets) {
      if (timesheets && timesheets.length) {
        let sum = 0;
        timesheets.forEach(sheet => {
          sum += sheet.hours_on_job + sheet.hours_pob
        })
        return sum > 0 ? sum.toFixed(2) : 0;
      }
      return ''
    },
    preparePlannerDialog(driverId) {
      this.plannerDialog = true
      this.selectedDriverId = driverId
    },
    copyContent (content) {
      console.log(content)
      if (content) {
        navigator.clipboard.writeText(content);
      }
    },
  },
  template: `
    <div class='template-wrap d-flex flex-row' >
    <v-flex xs5 >
      <v-list-item class="v-list-item-driver"
      >
        <v-list-item-avatar class="mr-0">
          <v-img max-width="20" max-height="20" :src="data.resourceData.picture"></v-img>
        </v-list-item-avatar>
        <v-list-item-content @click="preparePlannerDialog(data.resourceData.id)">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-subtitle
                  v-on="on"
                  v-bind="attrs"
                  style="font-size: 12px">
                {{data.resourceData.callsign + ' ' + data.resourceData.name.substr(0, 15)}}
                <br>
                {{
                  calculateWorkedHours(data.resourceData.timesheet)
                }}
              </v-list-item-subtitle>
            </template>
            <span>{{ data.resourceData.name }} </span>
          </v-tooltip>
          <small class="orange--text" v-if="data.resourceData.likelyWorking" colo v-html="'Likely Working'"></small>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex xs2 class="ml-2">
      <v-list-item class="v-list-item-driver"
      >
        <v-list-item-content>
          <v-list-item-subtitle style="font-size: 12px">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <a
                    href="#"
                    small
                    link
                    text
                    v-bind="attrs"
                    v-on="on"
                >
                  {{ 'Phone' }}
                </a>
              </template>
              <v-list dense class="pa-2">
                <v-list-item
                    link
                >
                  <v-list-item-title>
                    <a
                        :href="'mailto:' + data.resourceData.phone"
                    >Call</a>

                  </v-list-item-title>
                  <v-spacer />
                  <v-icon
                      small
                      color="blue"
                      class="ml-2"
                      @click="copyContent(data.resourceData.phone)"
                  >mdi-content-copy</v-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-subtitle>
          <v-list-item-subtitle style="font-size: 12px">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <a
                    href="#"
                    small
                    link
                    text
                    v-bind="attrs"
                    v-on="on"
                >
                  {{ 'Email' }}
                </a>
              </template>
              <v-list dense class="pa-2">
                <v-list-item
                    link
                >
                  <v-list-item-title>
                    <a
                        :href="'mailto:' + data.resourceData.email"
                    >Email</a>

                  </v-list-item-title>
                  <v-spacer />
                  <v-icon
                      small
                      color="blue"
                      class="ml-2"
                      @click="copyContent(data.resourceData.email)"
                  >mdi-content-copy</v-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex xs5>
      <v-list-item class="v-list-item-driver text-capitalize"
          v-if="data.resourceData.taxi"
      >
        <v-list-item-content>
          <v-list-item-subtitle style="font-size: 12px" v-html="data.resourceData.taxi.make + ' ' + data.resourceData.taxi.model"></v-list-item-subtitle>
          <v-list-item-subtitle style="font-size: 12px" v-html="data.resourceData.taxi.type"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex>
      <v-dialog
        v-model="plannerDialog"
        width="800"
      >
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Update Planner
            <v-spacer></v-spacer>
            <v-icon @click="plannerDialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <DriverPlanner class="pa-3" v-if="selectedDriverId" :driver-id="selectedDriverId"></DriverPlanner>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
    </div>`
});


export default {
  name: "DriversTimeLine",
  components: {
    DriverSearchBox
  },
  data() {
    return {
      days: {
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
        sunday: 7,
      },
      daysOrdinal: {
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday',
        7: 'sunday',
      },
      startHour: moment().format('HH') + ':00',
      startDay: moment().format('DD'),
      scheduleDate: moment().format('YYYY-MM-DD HH:mm'),
      selectedView: 'TimelineDay',
      previousView: '',
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
      },
      colorsArray: ['lime', 'navy', 'coral', 'crimson', 'darkblue', 'darkmagenta', 'darkviolet', 'indigo', 'mediumpurple', 'purple', 'blue', 'black', 'brown', 'maroon', 'green', 'red', 'turquioise', 'tomato', 'teal', 'seagreen', 'orange'],
      page: 1,
      timeScale: {
        enable: true,
        interval: 30,
        slotCount: 2
      },
      timeScaleWeek: {
        enable: true,
        interval: 60,
        slotCount: 1
      },
      eventTypes: {
        offDay: {
          color: '#e37d7d',
          name: 'Off Day'
        },
        upcomingAssignment: {
          color: '#e79898',
          name: 'Upcoming Pre Assignment',
          appBookingColor: '#8beccb',
          webBookingColor: '#d0de82',
          phoneBookingColor: '#ef5951',
          thirdPartyBookingColor: '#007903',
          kioskBookingColor: '#7f5b86',
          flagDownBookingColor: '#ecd091',
          repeatBookingColor: '#92aaf1',
        },
        privateTrip: {
          color: '#db74ea',
          name: 'Private Trip'
        },
        breakTime: {
          color: '#7599b0',
          name: 'Break Time'
        },
      },
      events: [],
      driver: null,
      drivers: [],
      bookings: [],
      offset: 0,
      count: 20,
      query: {
        pagination: true,
        search: "",
        rideType: [],
        lockedOut: false,
        plannerFilter: "",
        council: ""
      },
      loading: true,
      loadingDriver: false,
      pagination: {page: 1},
      num_pages: 0,
      noMoreResults: false,
      driverStats: null,
      selectedDate: new Date(),
      group: {
        resources: ['MeetingRoom']
      },
      ownerDataSource: [
        {text: 'Jammy', id: 1, color: '#1aaa55', capacity: 20, type: 'Conference'},
        {text: 'Tweety', id: 2, color: '#7fa900', capacity: 7, type: 'Cabin'},
        {text: 'Nestle', id: 3, color: '#5978ee', capacity: 5, type: 'Cabin'},
        {text: 'Phoenix', id: 4, color: '#fec200', capacity: 15, type: 'Conference'},
        {text: 'Mission', id: 5, color: '#df5286', capacity: 25, type: 'Conference'},
        {text: 'Hangout', id: 6, color: '#00bdae', capacity: 10, type: 'Cabin'},
        {text: 'Rick Roll', id: 7, color: '#865fcf', capacity: 20, type: 'Conference'},
        {text: 'Rainbow', id: 8, color: '#1aaa55', capacity: 8, type: 'Cabin'},
        {text: 'Swarm', id: 9, color: '#df5286', capacity: 30, type: 'Conference'},
        {text: 'Photogenic', id: 10, color: '#710193', capacity: 25, type: 'Conference'}
      ],
      resourceHeaderTemplate: function (e) {
        return {
          template: resourceHeaderTemplateVue
        };
      },
      eventSettings: {
        dataSource: this.events,
        enableTooltip: false,
        enableIndicator: true,
        enableMaxHeight: true
      },
      callCount: 0,
    }
  },
  computed: {
    yesterday () {
      return moment().subtract(1, 'day').toDate()
    },
    loadingDialog() {
      return this.$store.getters['loadingDialog']
    },
    eventsCollection() {
      return {dataSource: this.events,
        enableTooltip: false,
        enableIndicator: false,
        enableMaxHeight: false
      }
    }
  },
  watch: {
    'query.pagination': function (){
      if (!this.query.pagination) {
        this.offset = -1;
        this.getDrivers()
      } else {
        this.offset = 0
        this.getDrivers()
      }
    },
    drivers() {
      if (this.drivers && this.drivers.length) {
        this.getEvents()
      }
    }
  },
  created: async function () {
    this.getDrivers();
    this.getSummary();
  },
  mounted() {
    console.log('today is', this.whatDayIsItToday())
    // this.getEvents()
  },
  methods: {
    calculateWorkedHours(timesheets) {
      if (timesheets && timesheets.length) {
        let sum = 0;
        timesheets.forEach(sheet => {
          sum += sheet.hours_on_job + sheet.hours_pob
        })
        return sum > 0 ? sum.toFixed(2) : 0;
      }
      return ''
    },
    preparePlannerDialog () {
      this.$snackbar.show('Here we go')
    },
    colorWorkingHoursCells (cellDate, resourceIndex, args) {
      //collect the available time object from resource collection
      let differentTimeData = this.drivers[
          resourceIndex
          ].availableTimes;

      //apply the color based on the time
      for (let i = 0; i < differentTimeData.length; i++) {
        let startTimeDetails = differentTimeData[i].StartTime;
        let endTimeDetails = differentTimeData[i].EndTime;
        let startTime = startTimeDetails
        let endTime = endTimeDetails
        if (cellDate.getTime() >= startTime.getTime() && cellDate.getTime() < endTime.getTime()) {
          args.element.style.background = differentTimeData[i].CategoryColor
        }
      }
    },
    colorBreakHoursCells (cellDate, resourceIndex, args) {
      //collect the available time object from resource collection
      let differentTimeData = this.drivers[
          resourceIndex
          ].breakTimes;
      //apply the color based on the time
      for (let i = 0; i < differentTimeData.length; i++) {
        let startTimeDetails = differentTimeData[i].StartTime;
        let endTimeDetails = differentTimeData[i].EndTime;
        let startTime = startTimeDetails
        let endTime = endTimeDetails
        if (cellDate.getTime() >= startTime.getTime() && cellDate.getTime() < endTime.getTime()) {
          args.element.style.background = differentTimeData[i].CategoryColor
        }
      }
    },
    colorDaysOffCells (cellDate, resourceIndex, args) {
      //collect the available time object from resource collection
      let differentTimeData = this.drivers[
          resourceIndex
          ].daysOffTimes;
      //apply the color based on the time
      for (let i = 0; i < differentTimeData.length; i++) {
        let startTimeDetails = differentTimeData[i].StartTime;
        let endTimeDetails = differentTimeData[i].EndTime;
        let startTime = startTimeDetails
        let endTime = endTimeDetails
        if (cellDate.getTime() >= startTime.getTime() && cellDate.getTime() < endTime.getTime()) {
          args.element.style.background = differentTimeData[i].CategoryColor
        }
      }
    },
    whatDayIsItToday () {
      return moment().day()
    },
    convertToMiles(meters) {
      if (meters != 0) {
        return (meters/ 1609.34).toFixed(2)
      }
      return 0
    },
    convertSecondsToHoursMinutesSeconds (numSeconds) {
      let seconds = parseInt(numSeconds)
      return Math.floor(moment.duration(seconds,'seconds').asHours()) + 'hr' + moment.duration(seconds,'seconds').minutes() + 'mins';
    },
    popupOpen: (args) => {
      let isEmptyCell = false
      if (args.target) {
            isEmptyCell = args.target.classList.contains('e-work-cells') ||
            args.target.classList.contains('e-header-cells'); // checking whether the cell is empty or not
      }
      if ((args.type === 'QuickInfo' || args.type === 'Editor') && isEmptyCell) {
        args.cancel = true;
      }
      if ((args.type === 'Editor' || args.type === 'DeleteAlert')) {
        args.cancel = true;
      }
      if ((args.type === 'EventContainer')) {
        /*
        let categoryColor = args.data.event[0].CategoryColor;
        if (!args.element || !categoryColor) {
          return;
        }
        console.log('category color is:', categoryColor)
        args.element.style.backgroundColor = categoryColor;
        */
      }
    },
    onEventRendered: function(args) {
        let categoryColor = args.data.CategoryColor;
        if (!args.element || !categoryColor) {
          return;
        }
        args.element.style.backgroundColor = categoryColor;
      },
    navigateSchedule (data) {
      if (moment(data.currentDate).isAfter(moment())) {
        this.startHour = '00:00'
      } else {
        this.startHour = moment().format('HH') + ':00'
      }
      if (data.action == 'date') {
        this.selectedDate = moment(data.currentDate, 'YYYY-MM-DD HH:mm').toDate()
        this.getDrivers()
      }
      if (data.action == 'view') {
        if (data.currentView == 'TimelineWeek') {
          this.startHour = '00:00'
        }
        if (data.currentView == 'TimelineDay') {
          if (moment(data.currentDate).isAfter(moment())) {
            this.startHour = '00:00'
          } else {
            this.startHour = moment().format('HH') + ':00'
          }
        }
        this.selectedView = data.currentView
        this.getDrivers()
      }
    },
    loadPagination() {
      this.getDrivers()
    },
    onRenderCell: function (args) {
      if (args.elementType === 'emptyCells' && args.element.classList.contains('e-resource-left-td')) {
        let target = args.element.querySelector('.e-resource-text');
        target.innerHTML = '<table><tr><td style="padding-left: 15px;">Name</td><td style="padding-left: 45px;">Contact</td><td style="padding-left: 38px;">Vehicle</td></tr>';
      }

      if (args.element.classList.contains("e-work-cells")) {

        //get the date of the cell
        let cellDate = new Date(
            parseInt(args.element.getAttribute("data-date"))
        );

        //get the resource index
        let resourceIndex = parseInt(
            args.element.getAttribute("data-group-index")
        );
        this.colorWorkingHoursCells(cellDate, resourceIndex, args)
        this.colorBreakHoursCells(cellDate, resourceIndex, args)
        this.colorDaysOffCells(cellDate, resourceIndex, args)
      }
    },
    search: function () {
      this.pagination.page = 1;
      this.noMoreResults = false;
      this.getDrivers();
    },
    clear: function () {
      this.query = {
        search: "",
            rideType: [],
            lockedOut: false,
            plannerFilter: "filter_all",
      }
      this.getDrivers()
    },
    changePage: function (page) {
      this.pagination.page = page;
      this.getDrivers();
    },
    getDrivers: async function () {
      this.loading = true;

      try {
        let queryRideType =
            this.query.rideType == "" ? -1 : this.query.rideType;

        var url = `${this.$store.state.apiUrl}/driverPlanner/drivers_events_list?offset=${
            this.offset != -1 ? (this.count * (this.pagination.page - 1)) : -1
        }&count=${this.count}&filter=${this.query.plannerFilter == "" ? 'filter_all' : this.query.plannerFilter }`;
        if (this.query.rideType.length > 0) {
          for (var i = 0; i < this.query.rideType.length; i++) {
            url += `&rideType=${this.query.rideType[i]}`;
          }
        }

        url += `&lockedOut=${this.query.lockedOut}`;

        url += `&query=${this.query.search}`;
        let formattedSelectedDate = moment(this.selectedDate).format('YYYY-MM-DD')
        url += `&dateFilter=${formattedSelectedDate}`
        url += `&timePeriod=${this.prepareTimePeriodFilter(this.selectedView)}`
        if (this.query.council) {
          url +=`&council=${this.query.council}`
        }

        let response = await axios.get(url, {
          params: {},
        })


        if (response.data.error != null) {
          if (response.data.error == "no_results") {
            this.noMoreResults = true;
          } else {
            this.noMoreResults = false;
          }
        }
        var drivers = []
        if (response.data.drivers) {
          drivers = response.data.drivers;
        }

        if (drivers != null && drivers.length < this.count) {
          this.noMoreResults = true;
        } else if (drivers != null && drivers.length == this.count) {
          this.noMoreResults = false;
        }

        drivers.forEach((driver) => {
          driver.color = this.colorsArray[Math.floor(Math.random()*this.colorsArray.length)]
/*
          driver.availableTimes = [
            //different appointment time with color
            { startTime: "08:00", endTime: "10:00", color: "#efb6b6" },
            { startTime: "10:00", endTime: "12:00", color: "#abe6d6" },
            { startTime: "02:00", endTime: "16:00", color: "#f3e4ae" }
          ]
*/
          driver.availableTimes = this.prepareDriverWorkingHours(driver)
          driver.breakTimes = this.prepareDriverBreakHours(driver)
          driver.daysOffTimes = this.prepareDriverDayOff(driver)
        })
        this.drivers = drivers;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get drivers " + error);
      }
    },
    getDriver: async function (id) {
      this.loadingDriver = true;
      this.driver = null;

      try {
        var url = `${this.$store.state.apiUrl}/driver/${id}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driver = response.data;

        this.loadingDriver = false;
      } catch (error) {
        this.loadingDriver = false;
        console.log("Failed to get driver " + error);
      }
    },
    getSummary: async function (id) {
      try {
        var url = `${this.$store.state.apiUrl}/driver/summary`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driverStats = response.data;
      } catch (error) {
        console.log("Failed to get stats " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
    getEvents() {
      let events = []
      /**
       *
       * Preparing private trips
       *
       */
      events.push(...this.preparePrivateTripEvents())

      /**
       *
       * Preparing upcoming pre assignments
       *
       */
      events.push(...this.prepareUpcomingPreAssignmentEvents())
      /**
       *
       * Preparing breaks
       *
       */
      if (this.selectedView == 'TimelineMonth') {
        events.push(...this.prepareBreaksEvents())
        events.push(...this.prepareDaysOffEvents())
        events.push(...this.prepareWorkingDaysEvents())
      }
      this.events = events
    },
    prepareDaysOffEvents() {
      let events = []
      this.drivers.forEach(driver => {
        if (driver.daysOff) {
          driver.daysOff.forEach(trip => {
            events.push({
              StartTime: moment(trip.startDate, "YYYY-MM-DD hh:mm").toDate(),
              EndTime: moment(trip.endDate, "YYYY-MM-DD hh:mm").toDate(),
              Subject: this.eventTypes.offDay.name,
              CategoryColor: this.eventTypes.offDay.color,
              timed: true,
              eventData: trip,
              eventType: 'OffDay',
              driverId: driver.id
            })
          })
        }
      })
      return events
    },
    preparePrivateTripEvents() {
      let events = []
      this.drivers.forEach(driver => {
        if (driver.privateTrips) {
          driver.privateTrips.forEach(trip => {
            let startDate = moment(trip.startDate, "YYYY-MM-DD hh:mm").toDate()
            let endDate = moment(trip.endDate, "YYYY-MM-DD hh:mm").toDate()
            events.push({
              StartTime: startDate,
              EndTime: endDate,
              Subject: this.eventTypes.privateTrip.name,
              timed: true,
              eventData: trip,
              eventType: 'PrivateTrip',
              driverId: driver.id,
              CategoryColor: this.eventTypes.privateTrip.color
            })
          })
        }
      })
      return events
    },
    prepareBreaksEvents() {
      let breaks = []
      let formattedDate = moment().format("YYYY-MM-DD")
      this.drivers.forEach(driver => {
        if (driver.breaks) {
          driver.breaks.forEach(breakTime => {
            breaks.push({
              StartTime: moment(formattedDate + " " + breakTime.hoursPeriodStart, "YYYY-MM-DD hh:mm").toDate(),
              EndTime: moment(formattedDate + " " + breakTime.hoursPeriodEnd, "YYYY-MM-DD hh:mm").toDate(),
              Subject: this.eventTypes.breakTime.name,
              timed: true,
              eventData: breakTime,
              eventType: 'Break',
              driverId: driver.id,
              CategoryColor: this.eventTypes.breakTime.color
            })
          })
        }

      })

      return breaks
    },
    prepareWorkingDaysEvents() {
      let workingDays = []

      const lastdate=moment().endOf('month');
      this.drivers.forEach(driver => {
        const firstdate = moment().startOf('month');
        if (driver.working_hours) {
          while (firstdate <= lastdate) {
            const momentDay = this.daysOrdinal[moment(firstdate).day()]
            if (driver.working_hours[momentDay]) {
              workingDays.push({
                StartTime: moment(moment(firstdate).format("YYYY-MM-DD") + " " + driver.working_hours.start_time, "YYYY-MM-DD hh:mm").toDate(),
                EndTime: moment(moment(firstdate).format("YYYY-MM-DD") + " " + driver.working_hours.end_time, "YYYY-MM-DD hh:mm").toDate(),
                Subject: "Working Hours",
                timed: true,
                eventType: 'WorkingHour',
                driverId: driver.id,
                CategoryColor: '#c1ffdc'
              })
            }
            firstdate.add(1, 'days')
          }
        }

      })

      return workingDays
    },
    prepareDriverWorkingHours (driver) {
      let workingDays = []
      const lastdate=moment().endOf('month');
      const firstdate = moment();
      if (driver.working_hours) {
        while (firstdate <= lastdate) {
          const momentDay = this.daysOrdinal[moment(firstdate).day()]
          if (driver.working_hours[momentDay]) {
            workingDays.push({
              StartTime: moment(moment(firstdate).format("YYYY-MM-DD") + " " + driver.working_hours.start_time, "YYYY-MM-DD hh:mm").toDate(),
              EndTime: moment(moment(firstdate).format("YYYY-MM-DD") + " " + driver.working_hours.end_time, "YYYY-MM-DD hh:mm").toDate(),
              Subject: "Working Hours",
              timed: true,
              eventType: 'WorkingHour',
              driverId: driver.id,
              CategoryColor: '#c1ffdc'
            })
          }
          firstdate.add(1, 'days')
        }
      }
      return workingDays
    },
    prepareDriverBreakHours (driver) {
      let breakHours = []
      let formattedDate = moment().format("YYYY-MM-DD")
      if (driver.breaks) {
        driver.breaks.forEach(breakTime => {
          breakHours.push({
            StartTime: moment(formattedDate + " " + breakTime.hoursPeriodStart, "YYYY-MM-DD hh:mm").toDate(),
            EndTime: moment(formattedDate + " " + breakTime.hoursPeriodEnd, "YYYY-MM-DD hh:mm").toDate(),
            Subject: this.eventTypes.breakTime.name,
            timed: true,
            eventData: breakTime,
            eventType: 'Break',
            driverId: driver.id,
            CategoryColor: '#eae6ff'
          })
        })
      }

      return breakHours
    },
    prepareDriverDayOff (driver) {
      if (this.selectedView == 'TimelineMonth') {
        return []
      }
      let daysOff = []
      if (driver.daysOff) {
        driver.daysOff.forEach(dayOff => {
          daysOff.push({
            StartTime: moment(dayOff.startDate, "YYYY-MM-DD hh:mm").toDate(),
            EndTime: moment(dayOff.endDate, "YYYY-MM-DD hh:mm").toDate(),
            Subject: this.eventTypes.offDay.name,
            CategoryColor: 'rgba(255,172,172,0.98)',
            timed: true,
            eventData: dayOff,
            eventType: 'OffDay',
            driverId: driver.id
          })
        })
      }

      return daysOff
    },
    findNextBooking () {

    },
    prepareUpcomingPreAssignmentEvents() {
      let events = []
      this.drivers.forEach(driver => {
        if (driver.upcomingPreAssignments) {
          driver.upcomingPreAssignments.forEach(trip => {
            events.push({
              StartTime: moment(trip.pickupTime, "YYYY-MM-DD hh:mm").toDate(),
              EndTime: moment(trip.finishTime, "YYYY-MM-DD hh:mm").toDate(),
              Subject: this.prepareBookingSubject(trip),
              timed: false,
              Id: trip.booking.id,
              Description: this.prepareBookingDescription(trip),
              Location: this.prepareBookingLocations(trip),
              eventData: trip,
              CategoryColor: this.getBookingTypeColor(trip),
              eventType: 'UpcomingPreAssignment',
              driverId: driver.id
            })
          })
        }
      })

      return events
    },
    getEventColor(event) {
      return event.color
    },
    prepareBookingSubject(preassignment) {
      if (preassignment.booking) {
        return `${preassignment.booking.booking_type.toUpperCase()} Upcoming Preassignment`
      }

      return 'Upcoming Preassignment'
    },
    prepareBookingLocations (preassignment) {
      let locations = '<div style="font-size: 12px"><b>Pickup</b> <br> ' + preassignment.booking.pickup_location + "<br>" + '<b>Destination</b> <br>' + preassignment.booking.destinations[0].description + '</div>'
      return locations
    },
    prepareBookingDescription (preassignment) {
      return `
              <div style="font-size: 12px">
              <div>
              <b>Booking ID </b> ${preassignment.booking.id} <br>
              <b>Ref </b> ${preassignment.booking.ref_num} <br>
              <b>Account Name </b> ${preassignment.booking.business_customer_name ? preassignment.booking.business_customer_name : '' } <br>
              <b>Lead Passenger Name </b> ${preassignment.booking.user_name} <br>
              <b>Mileage </b> ${ this.convertToMiles(preassignment.booking.route_distance) + 'mi'} <br>
              <b>Duration </b> ${ this.convertSecondsToHoursMinutesSeconds(preassignment.booking.route_time)} <br>
              </div>
                <button class="popup-button" onclick="window.open('/bookings/' + ${preassignment.booking.id})">View Details</button>
            </div>
 `;
    },
    prepareTimePeriodFilter (currentView) {
      let views = {
        TimelineDay: 'day',
        TimelineWeek: 'week',
        TimelineMonth: 'month',
      }
      return views[currentView];
    },
    getBookingTypeColor (preassignment) {
      let colorsObject = {
        'repeat' : this.eventTypes.upcomingAssignment.repeatBookingColor,
        'phone' : this.eventTypes.upcomingAssignment.phoneBookingColor,
        'app' : this.eventTypes.upcomingAssignment.appBookingColor,
        'website' : this.eventTypes.upcomingAssignment.webBookingColor,
        'third_party' : this.eventTypes.upcomingAssignment.thirdPartyBookingColor,
        'kiosk' : this.eventTypes.upcomingAssignment.kioskBookingColor,
        'flag_down' : this.eventTypes.upcomingAssignment.flagDownBookingColor,
      }
      if (preassignment.booking && preassignment.booking.booking_type) {
        return colorsObject[preassignment.booking.booking_type]
      }
      return this.eventTypes.upcomingAssignment.color
    }
  },
  provide: {
    schedule: [TimelineViews, TimelineMonth]
  }
}
</script>
<style>

.e-schedule .e-timeline-view .e-resource-left-td {
  vertical-align: bottom;
}

.e-resource-left-td {
  color: #42b983;
  width: 280px !important;
}

.e-schedule .e-timeline-view .e-resource-left-td .e-resource-text {
  display: flex;
  padding: 0;
}

.e-schedule .e-timeline-view .e-resource-left-td .e-resource-text > div {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  flex: 0 0 33.3%;
  height: 25px;
  line-height: 30px;
  padding-left: 5px;
}

.e-schedule .e-timeline-view .e-resource-left-td .e-resource-text > div:last-child {
  border-right: 0;
}

.template-wrap::-webkit-scrollbar-button {
width: 0px;
height: 0px;
}

.e-schedule .template-wrap:hover {
  overflow-x: auto;
  overflow-y: hidden;

}

.e-schedule .template-wrap {
  display: flex;
  text-align: left;
  /*margin-right: 10px !important;*/
}

.e-schedule .template-wrap > div {
  /*border-right: 1px solid rgba(0, 0, 0, 0.12);*/
  flex: 0 0 30%;
  line-height: 50px;
  padding-left: 5px;
  text-overflow: ellipsis;
}



e-resource-text {
  margin-right: 25px !important;
}
.e-schedule .template-wrap > div:last-child {
  border-right: 0;
}

.e-schedule .e-timeline-view .e-resource-cells,
.e-schedule .e-timeline-month-view .e-resource-cells {
  padding-left: 0;
}

.e-schedule .e-timeline-view .e-date-header-wrap table col,
.e-schedule .e-timeline-view .e-content-wrap table col {
  width: 100px;
}

@media (max-width: 550px) {
  .e-schedule .e-timeline-view .e-resource-left-td {
    width: 100px;
  }

  .e-schedule .e-timeline-view .e-resource-left-td .e-resource-text > div,
  .e-schedule .template-wrap > div {
    flex: 0 0 100%;
  }

  .e-schedule .template-wrap > div:first-child {
    border-right: 0;
  }

  .e-schedule .e-timeline-view .e-resource-left-td .e-resource-text > div:first-child {
    border-right: 0;
    color: #999FB8;
  }

  .e-schedule .room-type,
  .e-schedule .room-capacity {
    display: none;
  }
}


.e-schedule .template-wrap .subject {
  font-weight: 600;
  font-size: 12px;
  padding: 4px 4px 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.e-schedule .template-wrap .time {
  height: 50px;
  font-size: 12px;
  padding: 4px 6px 4px;
  overflow: hidden;
}


/*
.e-table-container e-lib e-touch {
  height: 300px;
}
*/


/*
.e-event-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: whitesmoke;

  !* bring your own prefixes *!
  transform: translate(-50%, -50%);
}
*/

/*
.e-header-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: whitesmoke;

  !* bring your own prefixes *!
}
*/


div.e-header-calendar.e-control.e-calendar.e-lib {
  position: fixed;
}

div.e-popup-open {
  position: fixed;
  top: 20% !important;
}

.e-quick-popup-wrapper .e-event-popup .e-popup-footer {
  display: block;
}

.e-quick-popup-wrapper .e-popup-footer button:first-child {
  margin-right: 5px;
}

.popup-button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
}


.driver-row {
  -webkit-text-size-adjust: 100%;
  word-break: normal;
  tab-size: 4;
  font-size: 12px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-family: Roboto,sans-serif;
  line-height: 1.5;
  overflow-wrap: break-word;
  white-space: normal;
  background-repeat: no-repeat;
  box-sizing: inherit;
  margin: 0;
  align-items: center;
  display: flex;
  flex: 1 1 100%;
  letter-spacing: normal;
  outline: none;
  padding: 0 16px;
  position: relative;
  text-decoration: none;
  min-height: 88px;
  color: rgba(0,0,0,.87);
}

.flex-card {
  -webkit-text-size-adjust: 100%;
  word-break: normal;
  tab-size: 4;
  font-size: 12px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-family: Roboto,sans-serif;
  line-height: 1.5;
  background-repeat: no-repeat;
  box-sizing: inherit;
  padding: 0;
  margin: 0;
  border-width: thin;
  max-width: 100%;
  outline: none;
  text-decoration: none;
  transition-property: box-shadow,opacity;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
  display: flex!important;
  flex-direction: row!important;
  margin-bottom: 24px!important;
  border-radius: 0!important;
  color: rgba(0,0,0,.87);
  background-color: #f5f5f5!important;
  border-color: #f5f5f5!important;
}


.e-resource-cells.e-child-node {
  padding-left: 0px !important;
}

.v-list-item-driver {
  padding: 0px !important;
}



html.hydrated body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div#app div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-table-container.e-lib.e-touch div.e-table-wrap.e-timeline-view.e-timeline-day-view.e-current-panel table.e-schedule-table.e-outer-table tbody tr td.e-resource-left-td {
  line-height: 20px !important;
  padding-bottom: 24px;
}


.e-resource-column-table > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(1) {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}


#Schedule > div.e-table-container.e-lib.e-touch > div > table > tbody > tr:nth-child(2) > td:nth-child(1) > div > table > tbody > tr > td {
  padding-bottom: 0px !important;
}

#Schedule > div.e-table-container.e-lib.e-touch > div > table > tbody > tr:nth-child(1) > td.e-resource-left-td {
  padding: 18px !important;
}

#Schedule > div.e-table-container.e-lib.e-touch > div > table > tbody > tr:nth-child(1) > td:nth-child(2) > div > div > table {
  padding: 0px !important;
}

#Schedule > div.e-table-container.e-lib.e-touch > div > table > tbody > tr:nth-child(1) > td:nth-child(2) > div > div > table > tbody > tr:nth-child(1) > td {
  text-align: center;
}

td.e-time-slots {
  font-size: 12px !important;
  text-align: center;
}

span.e-header-date {
  left: 0;
  font-size: 12px;
}

.e-schedule .e-timeline-view .e-navigate {
  font-size: 12px;
}
.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-date-range .e-tbar-btn .e-tbar-btn-text {
  font-size: 12px !important;
}

#e-tbr-btn_3 > span {
  font-size: 12px;
}

.e-schedule .e-schedule-toolbar .e-tbar-btn .e-tbar-btn-text {
  font-size: 12px !important;
}


.e-header-icon-wrapper {
  padding: 0px !important;
}

.e-subject-wrap > div {
  font-size: 12px;
}

#Schedule > div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open > div > div.e-popup-header > div.e-subject-wrap > div {
  font-size: 14px !important;
}

#Schedule > div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open > div > div.e-popup-header > div.e-header-icon-wrapper {
  padding: 0px;
}

#Schedule > div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open > div > div.e-popup-header > div.e-subject-wrap {
  padding: 0px !important;
  text-align: center;
}

#Schedule > div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open > div > div.e-popup-header > div.e-header-icon-wrapper > button.e-edit.e-control.e-btn.e-lib.e-flat.e-round.e-small.e-icon-btn {
  display: none;
}

#Schedule > div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open > div > div.e-popup-header > div.e-header-icon-wrapper > button.e-delete.e-control.e-btn.e-lib.e-flat.e-round.e-small.e-icon-btn {
  display: none;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open div.e-event-popup div.e-popup-content div.e-resource div.e-resource-details.e-text-ellipsis {
  font-size: 12px;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open div.e-event-popup div.e-popup-content div.e-date-time div.e-date-time-wrapper.e-text-ellipsis div.e-date-time-details.e-text-ellipsis {
  font-size: 12px;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open div.e-event-popup div.e-popup-header div.e-header-icon-wrapper {
  display: none;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open div.e-event-popup div.e-popup-header div.e-subject-wrap div.e-subject.e-text-ellipsis {
  padding: 10px;
}

/***
alignment fix
 */

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.main-background.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-table-container.e-lib.e-touch div.e-table-wrap.e-timeline-view.e-current-panel table.e-schedule-table.e-outer-table tbody tr td div.e-date-header-container {
  margin: -3px !important;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.main-background.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-table-container.e-lib.e-touch div.e-table-wrap.e-timeline-view.e-current-panel table.e-schedule-table.e-outer-table tbody tr td div.e-content-wrap table.e-schedule-table.e-content-table {
 margin-left: -6px !important;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.main-background.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-table-container.e-lib.e-touch div.e-table-wrap.e-timeline-view.e-current-panel table.e-schedule-table.e-outer-table tbody tr td div.e-resource-column-wrap table.e-schedule-table.e-resource-column-table {
  width: 284px !important;
}

td.e-time-slots:nth-child(1) {
  padding: 13px !important;
}

div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap div.main-background.col main#main.v-main.v-content div.v-main__wrap.v-content__wrap div.ma-1 div#container div.schedule-vue-sample div.control-section div#Schedule.e-control.e-schedule.e-lib.quick-info-template.e-keyboard div.e-table-container.e-lib.e-touch div.e-table-wrap.e-timeline-month-view.e-current-panel table.e-schedule-table.e-outer-table tbody tr td div.e-resource-column-wrap table.e-schedule-table.e-resource-column-table {
  width: 284px;
}

#Schedule > div.e-table-container.e-lib.e-touch > div > table > tbody > tr:nth-child(1) > td:nth-child(2) > div {
  margin: -3px !important;
}

tr[role="row"] {
  height: 64px !important;
}

.e-resource-column-wrap tr {
  height: 64px !important;
}


</style>
